import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import VeeValidate, { Validator } from 'vee-validate';
import 'lib-flexible'


import store from './store'

//import MintUI from 'mint-ui'
import { Toast, Spinner, DatetimePicker, Picker, Popup, Indicator } from 'mint-ui';
import 'mint-ui/lib/style.css'

import util from '@/libs/util';
import validConfig from '@/libs/validConfig';
import ajax from '@/libs/ajax';
import { router } from './router/index';

//全局组件...
import global from './global/index';

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import Calendar from 'vue-mobile-calendar'

Vue.use(Calendar)

// mint components
Vue.prototype.$Toast = Toast;
Vue.prototype.$Indicator = Indicator;
Vue.component(Spinner.name, Spinner);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);

// global Functions
Vue.use(global)
Vue.use(VeeValidate, validConfig);
Vue.use(VueI18n);
Vue.use(iView);
Vue.prototype.$Cookies = Cookies;
Vue.prototype.$util = util;
Vue.prototype.$ajax = ajax;

Vue.filter("ifnulltozero",function (value, begin, xing) {
    return value!==''&&value!=undefined?value:'0';
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data: {
    currentPageName: ''
  },
  methods: {
    setBg() {
      document.body.style.backgroundColor = "transparent";//#f5f5f5
      if (this.$route.name == 'transaction_index') {
        document.body.style.backgroundColor = "#f5f5f5";
      } else {
        document.body.style.backgroundColor = "transparent";
      }
    }
  },
  watch: {
    "$route": function (data) {
      //获取并缓存code
      this.$util.getlocation().code ? Cookies.set("code", this.$util.getlocation().code) : '';
      this.setBg();
    }
  },
  mounted() {
    this.$Indicator.close();
  },
  created() {

  }
})



// WEBPACK FOOTER //
// ./src/main.js